class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
		this.quickFilters = document.querySelectorAll(
			".quick-filter:not(.quick-filter-reset)"
		);
		this.quickFiltersReset = document.querySelector(".quick-filter-reset");

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForm = this.querySelector("form");
		facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		// Convert searchParams to URLSearchParams object
		const urlSearchParams = new URLSearchParams(searchParams);

		// Check if any filters are selected (i.e., if searchParams has any keys related to filters)
		const hasFilters = Array.from(urlSearchParams.keys()).some((key) =>
			key.startsWith("filter.")
		);

		// Get the flag from sessionStorage (checks if availability filter has been applied before)
		const availabilityApplied =
			sessionStorage.getItem("availabilityApplied") === "true";

		if (hasFilters && !availabilityApplied) {
			// If there are filters and availability filter has not been applied yet, apply it
			urlSearchParams.set("filter.v.availability", "1");

			// Set the flag in sessionStorage to mark availability filter as applied
			sessionStorage.setItem("availabilityApplied", "true");
		} else if (!hasFilters) {
			// If no filters are selected, remove the availability filter and reset the flag
			urlSearchParams.delete("filter.v.availability");
			sessionStorage.removeItem("availabilityApplied"); // Reset the flag
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${
				section.section
			}&${urlSearchParams.toString()}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash)
			FacetFiltersForm.updateURLHash(urlSearchParams.toString());
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductGridContainer").innerHTML;
	}

	static renderProductCount(html) {
		const container = document.getElementById("ProductCount");

		if (!container) return;

		const count = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductCount").innerHTML;
		const containerDesktop = document.getElementById("ProductCountDesktop");
		container.innerHTML = count;

		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});

		document
			.getElementById("FacetFiltersFormMobile")
			.closest("menu-drawer")
			.bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	updateQuickFilters(searchParams) {
		const searchParamsObj = new URLSearchParams(searchParams);
		this.quickFilters.forEach((quickFilter) => {
			const filter = quickFilter.dataset.name;
			const value = quickFilter.dataset.value;
			const filterValues = searchParamsObj.getAll(filter);
			const filterIndex = filterValues.indexOf(value);
			if (filterIndex !== -1) {
				quickFilter.classList.add("active");
			} else {
				quickFilter.classList.remove("active");
			}
		});
		// if product_type filter is present in search params add active class to reset button and remove it if not
		if (
			this.quickFiltersReset &&
			searchParamsObj.has("filter.p.product_type")
		) {
			this.quickFiltersReset.classList.remove("active");
		} else {
			this.quickFiltersReset.classList.add("active");
		}
	}

	onSubmitHandler(event) {
		event.preventDefault();
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			this.onSubmitForm(searchParams, event);
			if (this.quickFilters.length > 0) this.updateQuickFilters(searchParams);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest("form").id === "FacetFiltersFormMobile";

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (
						form.id === "FacetSortForm" ||
						form.id === "FacetFiltersForm" ||
						form.id === "FacetSortDrawerForm"
					) {
						const noJsElements = document.querySelectorAll(".no-js-list");
						noJsElements.forEach((el) => el.remove());
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === "FacetFiltersFormMobile") {
					forms.push(this.createSearchParams(form));
				}
			});
			this.onSubmitForm(forms.join("&"), event);
			if (this.quickFilters.length > 0)
				this.updateQuickFilters(forms.join("&"));
		}
	}

	onActiveFilterClick(event) {
		const quickFilterSelector = event?.target?.innerText
			?.replace("Category:", "")
			.replace("Remove filter", "")
			.trim();

		// try catch in case of an invalid selector
		try {
			document
				.querySelector(
					`quick-filters span[data-value="${quickFilterSelector}"]`
				)
				?.classList.remove("active");
		} catch (e) {}

		if (document.querySelectorAll("quick-filters span.active")?.length == 0) {
			document
				.querySelector("quick-filters span[data-quick-filter-value='reset']")
				?.classList.add("active");
		}

		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  resetQuickFiltersUI() {
    document.querySelectorAll("quick-filters span").forEach((element) => element.classList.remove("active"));
    document.querySelector("quick-filters span[data-quick-filter-value='reset']").classList.add("active");
  }

  closeFilter(event) {
    if (event.target.classList.contains("mobile-facets__clear") || event.target.classList.contains("remove-all")) {
      this.resetQuickFiltersUI();
    }
    event.preventDefault();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

class QuickFilters extends HTMLElement {
  constructor() {
    super();
    this.quickFilters = this.querySelectorAll(".quick-filter:not(.quick-filter-reset)");
    this.quickFiltersReset = this.querySelector(".quick-filter-reset");
  }

  // adds event listeners to quick filters
  connectedCallback() {
    this.updateActiveClassesOnLoad();
    this.quickFilters.forEach((quickFilter) => {
      quickFilter.addEventListener("click", this.onQuickFilterClick.bind(this));
    });
    this.quickFiltersReset.addEventListener("click", this.formSubmitReset.bind(this));
  }

  updateActiveClassesOnLoad() {
    const searchParams = new URLSearchParams(window.location.search);
    this.quickFilters.forEach((quickFilter) => {
      const filter = quickFilter.dataset.name;
      const value = quickFilter.dataset.value;
      const filterValues = searchParams.getAll(filter);
      const filterIndex = filterValues.indexOf(value);
      if (filterIndex !== -1) {
        quickFilter.classList.add("active");
      }
    });
    // if product_type filter is present in search params add active class to reset button and remove it if not
    if (searchParams.has("filter.p.product_type")) {
      this.quickFiltersReset.classList.remove("active");
    } else {
      this.quickFiltersReset.classList.add("active");
    }
  }

  // adds or removes quick filters from the URL
  onQuickFilterClick(event) {
    this.quickFiltersReset.classList.remove("active");
    if (!event.target.classList.contains("active")) {
      event.target.classList.add("active");
    } else {
      event.target.classList.remove("active");
    }

    const searchParams = new URLSearchParams(window.location.search);
    const filter = event.target.dataset.name;
    const value = event.target.dataset.value;
    const filterValues = searchParams.getAll(filter);
    const filterIndex = filterValues.indexOf(value);
    searchParams.delete("page");

    if (filterIndex === -1) {
      searchParams.append(filter, value);
    } else {
      searchParams.delete(filter, value);
    }

    this.formSubmit(searchParams.toString(), event);

    let activeFilters = false;

    this.quickFilters.forEach((quickFilter) => {
      if (quickFilter.classList.contains("active")) {
        activeFilters = true;
      }
    });

    if (!activeFilters) {
      this.quickFiltersReset.classList.add("active");
    }
  }

  // removes only params added by quick filters
  formSubmitReset(event) {
    const searchParams = new URLSearchParams(window.location.search);
    this.quickFilters.forEach((quickFilter) => {
      const filter = quickFilter.dataset.name;
      searchParams.delete(filter);
    });
    this.formSubmit(searchParams.toString(), event);

    this.quickFilters.forEach((quickFilter) => {
      quickFilter.classList.remove("active");
    });
    this.quickFiltersReset.classList.add("active");
  }

  // submits the form with the new search params
  formSubmit(searchParams, event) {
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onSubmitForm(searchParams, event);
  }
}

customElements.define("quick-filters", QuickFilters);
